var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{staticClass:"icon-collapse",class:{'icon-collapse--open':_vm.open},attrs:{"type":"tertiary","aria-label":_vm.labelButton},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"icon",fn:function(){return [(_vm.open)?_c('ChevronUp',{attrs:{"size":20}}):_c('ChevronDown',{attrs:{"size":20}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }